import { DialogDraggable } from '@bloomfieldrobotics/canopy';
import { DialogContent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import {
  selectIsOpenMeasurementPopup,
  setIsOpenMeasurementPopup,
} from '../../mapSlice';
import MapMeasureDialogContent from './MapMeasureDialogContent';

const MapMeasureDialog: React.FC = () => {
  const isOpenDialog = useAppSelector(selectIsOpenMeasurementPopup);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(setIsOpenMeasurementPopup(false));
  };

  return (
    <>
      <DialogDraggable
        title={t('Measure', { ns: 'common' })}
        open={isOpenDialog}
        onClose={handleClose}
        maxWidth={false}
      >
        <DialogContent>
          <MapMeasureDialogContent />
        </DialogContent>
      </DialogDraggable>
    </>
  );
};

export default MapMeasureDialog;
